import type { DisplayMarketingCampaign } from "@common/interfaces/KYDMarketing";
import { PublisherPlatforms } from "@common/interfaces/KYDMarketing";

/** Unique Facebook page ids referenced by ad creatives (for IG account fetch). */
export function collectFacebookPageIdsFromCampaign(
  campaign: DisplayMarketingCampaign | null | undefined
): string[] {
  const ids = new Set<string>();
  for (const adset of campaign?.adsets ?? []) {
    for (const ad of adset.ads ?? []) {
      const cp =
        ad.creative?.identity?.[PublisherPlatforms.facebook]?.page_id?.trim();
      if (cp) ids.add(cp);
    }
  }
  return Array.from(ids);
}
